export default {
  failed_to_open: 'Nu s-a putut deschide configurarea pentru acest restaurant. Vă rugăm să încercați din nou.',
};
